<template>
  <a
    :class="additionalClasses"
    :href="href"
    target="_blank"
    rel="external, nofollow"
    aria-label="External link"
  >
    <slot>
      {{ label }}
    </slot>
  </a>
</template>

<script setup lang="ts">
defineProps({
  href: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    default: "",
  },
  additionalClasses: {
    type: String,
    default: "",
  },
});
</script>
